import { inject, Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { IIncentive } from "projects/lib-ui/src/shared/interfaces/incentive";
import { IResponse } from "projects/lib-ui/src/shared/interfaces/response";
import { INCENTIVE_IMG_DEFAULT } from "projects/lib-ui/src/shared/constants/incentive-img-default.const";

@Injectable({
  providedIn: 'root'
})
export class IncentiveService {
  private readonly URI_API = environment.URLAPI;

  private readonly httpclient = inject(HttpClient);

  getBranchById(id: string): Observable<IIncentive | null> {
    return this.httpclient.get<IResponse<IIncentive>>(
      `${this.URI_API}Incentive/${id}`
    ).pipe(
      map(response => {
        if (!response || !response.success || !response.data) {
          return null;
        }
        return {
          ...response.data,
          noticePageImg: response.data.noticePageImg ?? INCENTIVE_IMG_DEFAULT,
          winnerPageImg: response.data.winnerPageImg ?? INCENTIVE_IMG_DEFAULT
        };
      })
    );
  }
}
